<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
    <app-loading v-show="loading"/>
  </div>
</template>

<script>
import { getCurrentUsername } from '@/api/user';
import uhiddenUtil from '@/utils/uhiddenUtil';

import Loading from '@/components/common/Loading'

export default {
  name: 'App',
  components:{
    'app-loading':Loading
  },
  data () {
    return {
      uhidden: '',
    }
  },
  computed:{
    loading(){
      return this.$store.getters.loading
    },
  },
  created() {

  },
  mounted() {
    // const b = this.getParamFromHash('b');
    // if (b) {
    //   sessionStorage.setItem('param_b', b);
    // }

    // this.uhidden = uhiddenUtil.getOrCreateHidden();
    // this.getCurrenUser()

  },
  methods: {
    getParamFromHash(name) {
      const hash = window.location.hash || '';
      const queryIndex = hash.indexOf('?');
      if (queryIndex === -1) return null;

      const queryString = hash.substring(queryIndex + 1);
      const params = new URLSearchParams(queryString);
      return params.get(name);
    },


  },
  
}
</script>

<style>
/*页面切换动画*/
/*进入过渡的结束状态，元素被插入时就生效，在过渡过程完成后移除*/
.fade-enter-active {
    transition: opacity .1s;
}
/*进入过渡的开始状态，元素被插入时生效，只应用一帧后立刻删除*/
.fade-enter {
    opacity: 0;
}
/*离开过渡的开始状态，元素被删除时触发，只应用一帧后立刻删除*/
.fade-leave {
    opacity: 1;
}
/*离开过渡的结束状态，元素被删除时生效，离开过渡完成后被删除*/
.fade-leave-active {
    opacity:0;
    transition: opacity .1s;
}


</style>



// WEBPACK FOOTER //
// src/App.vue